import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { fields } from "../../common/lib/redux-fields";
import { ValidationError } from "../../common/lib/validation";

import {
  Container,
  Row,
  Col,
  Form as BootstrapForm,
  FormGroup,
  Label,
  FormFeedback,
  Button
} from "reactstrap";

import { updateProfile } from "../../common/admin/actions";
import { clearError, clearForm } from "../../common/admin/actions";

import ButtonWithLoader from "../../browser/components/Form/ButtonWithLoader";
import Input from "../../browser/components/Form/Input";
import Dropzone from "../../browser/components/Form/Dropzone";

const formFields = ["password", "confirmPassword"];

class Form extends React.Component {
  constructor() {
    super();

    this.update = this.update.bind(this);
    this.clearError = this.clearError.bind(this);
  }

  componentDidMount() {
    const { params, get, editForm, fields, clearForm } = this.props;

    fields.$reset();
    clearForm();
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  async update(e) {
    const { fields, viewer } = this.props;
    const { update, clearForm } = this.props;
    e.preventDefault();
    const values = fields.$valuesChanged();

    if (Object.keys(values).length > 0) {
      values.uid = viewer.uid;

      const rs = await update(values);

      if (rs && (rs.status === 200 || rs.status === 204)) {
        fields.$reset();
      }
    }
  }

  clearError(field) {
    const { clearError } = this.props;

    clearError(field);
  }

  render() {
    const { apiHost, fields, form, obj } = this.props;

    const dirty = Object.keys(fields.$valuesChanged()).length > 0;
    return (
      <BootstrapForm onSubmit={this.update} noValidate>
        <Container>
          <Row>
            <Col xs="6">
              <Input
                field="changePassword"
                title="Nowe hasło"
                type="password"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "changePassword")}
                noError
                {...fields.password}
              />
              <Input
                field="changePassword"
                title="Potwierdź hasło"
                type="password"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "changePassword")}
                {...fields.confirmPassword}
              />
            </Col>
            <Col xs="6" />
            <ButtonWithLoader
              className="button-loader"
              size="lg"
              color={dirty ? "warning" : "success"}
              text={"Zapisano"}
              isLoading={form.get("loading")}
              loadingText={"Zapisuję zmiany..."}
              isDirty={dirty}
              dirtyText={"Zapisz zmiany"}
            />
          </Row>
        </Container>
      </BootstrapForm>
    );
  }
}

Form.contextTypes = {
  router: React.PropTypes.object.isRequired
};

Form = fields(Form, {
  path: "profileForm",
  fields: formFields,
  getInitialState: ({ obj, editForm }) => {
    return {
      password: "",
      confirmPassword: ""
    };
  }
});

Form = connect(
  state => ({
    apiHost: state.config.apiHost,
    form: state.admin.form,
    fields: state.fields,
    viewer: state.auth.viewer
  }),
  { clearError, clearForm, update: updateProfile }
)(Form);

export { Form, formFields };



// WEBPACK FOOTER //
// ./src/browser/profile/Form.js